export default function DocumentsIcon() {
  return (
    <svg
      width="19"
      height="23"
      viewBox="0 0 19 23"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 0.0415039C1.52411 0.0415039 0.125 1.44062 0.125 3.1665V19.8332C0.125 21.5591 1.52411 22.9582 3.25 22.9582H15.75C17.4759 22.9582 18.875 21.5591 18.875 19.8332V8.19612C18.875 7.36732 18.5457 6.57246 17.9597 5.98641L12.9301 0.956796C12.3441 0.370743 11.5492 0.0415039 10.7204 0.0415039H3.25ZM2.20833 3.1665C2.20833 2.59121 2.67471 2.12484 3.25 2.12484H9.5V7.33317C9.5 8.48376 10.4327 9.4165 11.5833 9.4165H16.7917V19.8332C16.7917 20.4085 16.3253 20.8748 15.75 20.8748H3.25C2.67471 20.8748 2.20833 20.4085 2.20833 19.8332V3.1665ZM16.3602 7.33317L11.5833 2.55631V7.33317H16.3602Z"
        fill="currentColor"
      />
    </svg>
  );
}
